<div class="table-section">
  <h1 translate>{{formType}}</h1>
  <form [formGroup]="form" class="mb-4" (ngSubmit)="onSubmit($event.submitter?.id)">
    <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options" (modelChange)="onModelChange()"></formly-form>
    <ng-container [ngTemplateOutlet]="buttons"></ng-container>

    <div id="form-actions" class="bg-light border-bottom py-2 no-print">
      <div class="container">
        <button id="back" class="btn btn-secondary me-3" (click)="navigateHome()"><i class="bi bi-arrow-left"></i> Home</button>
        <ng-container [ngTemplateOutlet]="buttons"></ng-container>
      </div>
    </div>
  </form>
</div>

<ng-template #buttons>
  @if(showWithdrawButton){
  <span class="d-inline-block" tabindex="0" ngbTooltip="Withdraw an submitted form to make changes" placement="bottom">
    <button id="withdraw" type="submit" class="btn btn-primary me-3 no-print"><i class="bi bi-clipboard-check"></i> Withdraw</button>
  </span>
  }
  @if(showSaveButton) {
  <span class="d-inline-block" tabindex="0" ngbTooltip="Save changes" placement="bottom">
    <button id="save" type="submit" class="btn btn-primary me-3 no-print"><i class="bi bi-floppy"></i> Save</button>
  </span>
  <span class="d-inline-block" tabindex="0" [ngbTooltip]="!form.valid ? 'Please fill all mandatory information before submitting for review' : 'Submit for review'" placement="bottom">
    <button id="submit" type="submit" class="btn btn-primary me-3 no-print" [disabled]="!form.valid"><i class="bi bi-clipboard-check"></i> Submit</button>
  </span>

  }
  <div ngbDropdown class="d-inline-block">
    <button type="button" class="btn btn-primary me-3 no-print" id="dropdownOtherActions" ngbDropdownToggle><i class="bi bi-three-dots"></i> Other actions</button>
    <div ngbDropdownMenu aria-labelledby="dropdownOtherActions">
      <button ngbDropdownItem id="copy" type="submit"><i class="bi bi-copy"></i> Copy</button>
      <button ngbDropdownItem id="delete" type="submit" [disabled]="!showDeleteButton"><i class="bi bi-trash"></i> Delete</button>
    </div>
  </div>
</ng-template>